import { AxiosResponse } from 'axios';

import {
  CarbonOffsetProjectCategoriesI,
  CarbonOffsetProjectListI,
} from '../../declarations/interfaces/carbonOffset';
import { get } from '../api';

export const getCarbonOffsetCategories = async (): Promise<
  AxiosResponse<{ carbonOffsetProjectCategories: CarbonOffsetProjectCategoriesI[] }>
> => await get(`/product/carbon-offset/carbon-offset-categories`);

// TODO figure out where should be taken and why it needed `/1` at the end of endpoint
export const getCarbonOffsetProjectList = async (
  customerId: string
): Promise<AxiosResponse<CarbonOffsetProjectListI>> =>
  await get(`/product/carbon-offset/projects/customer/${customerId}/1/localization`);
